export { datepickerVariables as datepickerCalendarHeaderVariables } from './datepickerVariables';
